import * as $ from 'jquery';

export type TimerDoneCallback = () => void;

export class LessonTimer {
    seconds: number;
    timerid: string;
    timerDoneFunc: TimerDoneCallback;
    $element: JQuery;

    constructor(seconds: number, timerid: string, timerDoneFunc: TimerDoneCallback) {
        this.seconds = seconds;
        this.timerid = timerid;
        this.timerDoneFunc = timerDoneFunc;
        this.$element = $('#' + this.timerid);
    }

    start() {
        const self = this;
        (<any>this.$element).countdown(
            {
                until: self.seconds,
                compact: true,
                description: '',
                format: 'HMS',
                onExpiry: function () {
                    if (self.timerDoneFunc) {
                        self.timerDoneFunc();
                    }
                }
            }
        );
    };

    formatElement($el: JQuery) {
        if (this.$element.length) {
            const val = (<any>(this.$element)).countdown('getTimes');
            if (val) {
                $el.html(val.slice(4, 7).join(':'));
            }
        }
    };
}
